import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M153.664 333.248a204.8 204.8 0 1 0 409.6 0 204.8 204.8 0 1 0-409.6 0zm153.536 256h102.4a307.2 307.2 0 0 1 307.136 307.2H0a307.2 307.2 0 0 1 307.2-307.2z" /><path d="M716.8 589.248a307.2 307.2 0 0 1 306.944 295.68l.256 11.52H767.936a358.08 358.08 0 0 0-172.8-306.624c6.4-.384 12.8-.576 19.328-.576h102.4zm-102.4-460.8a204.8 204.8 0 1 1-81.92 392.576 255.168 255.168 0 0 0 81.92-187.776A255.232 255.232 0 0 0 532.48 145.6c25.856-11.328 53.76-17.152 81.92-17.088z" /></svg>

const Groups = React.forwardRef((props, ref) => {
  return (
    <IconBase name="groups" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Groups.displayName = 'IconGroups'

export default Groups
